import React from 'react'
import Colors from 'utils/Colors'
import { formatDateTime, maskString } from 'utils/functions'
import { FindInPage, Remove } from '@mui/icons-material'
import { REVIEW_THEMES } from 'utils/constants/bgcFields'
import { Tooltip } from '@mui/material'
import { SUSPENDED_ANALYSIS_MESSAGE } from 'utils/constants/application'
import ReviewButton from '../ReviewButton'
import { StatusText, TableColumn } from './styles'

const ReviewRow = (props) => {
  const { review, onClick, checkType } = props

  const key = checkType ? 'reference_check' : 'background_check'

  const getReviewStatus = (decision, waitingClarification) => {
    const status = {
      APPROVED: <StatusText style={{ color: Colors.green }}>Aprovado</StatusText>,
      REPROVED: <StatusText style={{ color: Colors.red }}>Reprovado</StatusText>,
      WAITING_DECISION: <StatusText style={{ color: Colors.loginLigthenPrimaryColor }}>Aguardando Revisão</StatusText>,
      WAITING_CLARIFICATION: <StatusText style={{ color: Colors.blue }}>Aguardando Esclarecimentos</StatusText>,
      SUSPENDED: (
        <Tooltip arrow title={<h4>{SUSPENDED_ANALYSIS_MESSAGE}</h4>}>
          <StatusText style={{ color: Colors.orange }}>Suspensa </StatusText>
        </Tooltip>
      ),
    }

    return (
      status[waitingClarification ? 'WAITING_CLARIFICATION' : decision]
    )
  }

  const getReviewerEmail = (email) => {
    return email || <Remove style={{ color: '#AAA' }} />
  }

  const getReviewerName = (name) => {
    return name || <Remove style={{ color: '#AAA' }} />
  }

  const getReviewDecisionTimestamp = (decisionTimestamp) => {
    return (decisionTimestamp && formatDateTime(decisionTimestamp)) || <Remove style={{ color: '#AAA' }} />
  }

  return (
    <tr id={review[key]?.person?.uuid}>
      <td>{formatDateTime(review?.created)}</td>
      <TableColumn>{getReviewerName(review[key]?.person?.name?.toLowerCase())}</TableColumn>
      <td>{maskString(review[key]?.person?.cpf, 'cpf')}</td>
      <td>{REVIEW_THEMES[review.review_type]}</td>
      <td>{review?.issue}</td>
      <td>{getReviewerEmail(review?.reviewer?.email)}</td>
      <td>{getReviewDecisionTimestamp(review.decision_timestamp)}</td>
      <td>{getReviewStatus(review.decision, review.waiting_clarification)}</td>
      <td>
        {review.decision === 'WAITING_DECISION' ? (
          <ReviewButton
            id={review.uuid}
            color={Colors.white}
            backgroundColor={Colors.blue}
            borderColor={Colors.darkBlue}
            icon={<FindInPage fontSize="small" />}
            onClick={onClick}
            text="Revisar"
          />
        ) : (
          <ReviewButton
            id={review.uuid}
            color="#676767"
            backgroundColor={Colors.white}
            borderColor="#ddd"
            icon={<FindInPage fontSize="small" />}
            onClick={onClick}
            text="Exibir"
          />
        )}
      </td>
    </tr>
  )
}

export default ReviewRow
